import React from 'react';

/* ── Geometria identica a Menu.js / MenuSvgOverlay ── */
const startTL = { x: 280, y: 250 };
const DX = 40, DY = 55, SVG_W = 800, N = 8;
const shapes = Array.from({ length: N }, (_, i) => {
    const TL = { x: startTL.x + DX * i, y: startTL.y + DY * i };
    const TR = { x: TL.x + SVG_W, y: TL.y };
    const BL = { x: TL.x - 260,   y: TL.y + 500 };
    const BR = { x: TR.x - 260,   y: TR.y + 500 };
    return { TL, TR, BR, BL };
});
function shapeOpacity(i) { return i < 3 ? 0.8 : 0.8 - (i - 2) * 0.15; }

const HEADER_H  = 429;
const GRAD      = 'linear-gradient(90deg, #981914 0%, #E3664C 100%)';

export default function TestChiSiamo() {
    return (
        <div style={{ background: '#fff', minHeight: '100vh', fontFamily: "'Roboto', sans-serif", fontWeight: 300 }}>

            {/* ── Header rosso con SVG parallelogrammi ── */}
            <div style={{
                position:     'relative',
                height:       HEADER_H,
                background:   GRAD,
                overflow:     'hidden',
                borderBottom: '2px solid rgba(255,255,255,0.25)',
            }}>
                {/* viewBox "-110 200 1600 800" — stessa usata in modalità header dall'overlay */}
                <svg
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: 'auto', display: 'block' }}
                    viewBox="-110 200 1600 800"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {shapes.map((sh, i) => {
                        const d = `M ${sh.TL.x} ${sh.TL.y} L ${sh.TR.x} ${sh.TR.y} L ${sh.BR.x} ${sh.BR.y} L ${sh.BL.x} ${sh.BL.y} Z`;
                        return (
                            <path
                                key={i}
                                d={d}
                                fill="none"
                                stroke={`rgba(255,255,255,${shapeOpacity(i)})`}
                                strokeWidth="2"
                                vectorEffect="non-scaling-stroke"
                            />
                        );
                    })}
                </svg>

                {/* Titolo pagina — in basso a destra, come da XD */}
                <div style={{
                    position:       'absolute',
                    top:            0,
                    right:          'clamp(24px, 5vw, 120px)',
                    bottom:         0,
                    display:        'flex',
                    flexDirection:  'column',
                    alignItems:     'flex-end',
                    justifyContent: 'center',
                    zIndex:         2,
                }}>
                    <h1 style={{
                        fontFamily:    "'Poppins', sans-serif",
                        fontWeight:    700,
                        fontSize:      'clamp(24px, 3.5vw, 52px)',
                        color:         '#fff',
                        textTransform: 'uppercase',
                        letterSpacing: '0.06em',
                        margin:        0,
                        textAlign:     'right',
                        whiteSpace:    'nowrap',
                    }}>
                        Chi Siamo
                    </h1>
                </div>
            </div>

            {/* ── Contenuto pagina ── */}
            <div style={{ padding: '60px clamp(24px, 10vw, 140px)' }}>
                <h2 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600, color: '#981914', marginBottom: 16 }}>
                    Studio ESI.Pro
                </h2>
                <p style={{ fontSize: 17, lineHeight: 1.8, maxWidth: 680, color: '#333' }}>
                    Studio di architettura e ingegneria con oltre vent'anni di esperienza
                    nella progettazione di spazi pubblici e privati di qualità.
                    Approccio integrato che unisce design architettonico, ingegneria e sostenibilità.
                </p>

                <div style={{
                    display:             'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                    gap:                 24,
                    marginTop:           48,
                }}>
                    {[
                        { title: 'La nostra storia',  body: 'Fondato nel 2003, ESI.Pro ha realizzato oltre 200 progetti nel territorio nazionale.' },
                        { title: 'Metodologia',       body: 'Approccio integrato che unisce design architettonico, ingegneria e sostenibilità.' },
                        { title: 'Il team',           body: 'Oltre 30 professionisti tra architetti, ingegneri, esperti BIM e project manager.' },
                    ].map(card => (
                        <div key={card.title} style={{
                            background:  '#f8f8f8',
                            borderLeft:  '4px solid #981914',
                            padding:     '24px',
                            borderRadius: 4,
                        }}>
                            <h3 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400, color: '#981914', marginBottom: 8, fontSize: 15 }}>{card.title}</h3>
                            <p  style={{ fontSize: 13, color: '#555', lineHeight: 1.6, margin: 0 }}>{card.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
